import React, { FC, ReactElement } from 'react';
import { Outlet, useOutletContext } from 'react-router';
import { Navigate } from 'react-router-dom';

interface Props {
  element?: ReactElement;
}

const ProtectedRoute: FC<Props> = (props) => {
  const session: any = useOutletContext();
  return session?.data ? props.element || <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
